module.exports = __webpack_public_path__ + "static/media/desktop-laptop-studying-pen.159d2efa.png";